import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import RemoveIcon from '@mui/icons-material/Remove';
import RefreshIcon from '@mui/icons-material/Refresh';

import { FieldsRow } from '../../../../../../shared/components/form';
import { ConfirmationPopup } from '../../../../../../shared/components/popupTemplates/cofirmationPopup/confirmation.popup';
import { IconButton } from '../../../../../order/common/iconButton/iconButton.component';
import { CustomerCRMNote } from '../../../../services/customer.service';
import { crmTabState } from '../crm.state';
import { AddOrEditNote } from '../popups/addOrEditNote/addOrEditNote.popup';

/* The toolbar of the Windows CRM tab, same four actions in the same order:
insert, edit, delete (behind a confirmation) and refresh. */
export const ControlButtons: FC<IControlButtons> = (props) => {
  const { selectedNote, addOrEditNotePopup, deleteNotePopup } = props;
  const { t } = useTranslation();

  return (
    <FieldsRow marginBottom={1} alignItems='center' spacing={0}>
      <Stack direction='row' spacing={2}>
        <IconButton
          color='primary'
          size='large'
          title={t('customer.addNewRecord')}
          onClick={() => addOrEditNotePopup.stream.emit('open', { values: {} })}
        >
          <AddIcon />
        </IconButton>
        <IconButton
          color='primary'
          size='large'
          title={t('customer.editRecord')}
          disabled={!selectedNote}
          onClick={() =>
            selectedNote &&
            addOrEditNotePopup.stream.emit('open', { values: { note: selectedNote } })
          }
        >
          <EditIcon />
        </IconButton>
        <IconButton
          color='primary'
          size='large'
          title={t('customer.deleteRecord')}
          disabled={!selectedNote}
          onClick={() =>
            selectedNote &&
            deleteNotePopup.stream.emit('open', {
              message: t('customer.delete_crm_note_confirmation'),
              onApply: () => crmTabState.pub.deleteRecord({ id: selectedNote.id }),
            })
          }
        >
          <RemoveIcon />
        </IconButton>
        <IconButton
          color='primary'
          size='large'
          title={t('common.refresh')}
          onClick={() => crmTabState.pub.refresh()}
        >
          <RefreshIcon />
        </IconButton>
      </Stack>
    </FieldsRow>
  );
};

interface IControlButtons {
  selectedNote: CustomerCRMNote | null;
  addOrEditNotePopup: AddOrEditNote;
  deleteNotePopup: ConfirmationPopup;
}
